module.exports = __webpack_public_path__ + "static/media/mouse.c1e65d4c.svg";